/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TagFromJSON, TagToJSON, } from './Tag';
/**
 * Check if a given object implements the ListTagsResponse interface.
 */
export function instanceOfListTagsResponse(value) {
    if (!('tags' in value) || value['tags'] === undefined)
        return false;
    if (!('count' in value) || value['count'] === undefined)
        return false;
    return true;
}
export function ListTagsResponseFromJSON(json) {
    return ListTagsResponseFromJSONTyped(json, false);
}
export function ListTagsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tags': (json['tags'].map(TagFromJSON)),
        'count': json['count'],
    };
}
export function ListTagsResponseToJSON(json) {
    return ListTagsResponseToJSONTyped(json, false);
}
export function ListTagsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tags': (value['tags'].map(TagToJSON)),
        'count': value['count'],
    };
}
